export default __webpack_public_path__ + "static/media/flag.8831d385.svg";